import {
  Component,
  computed,
  HostBinding,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MenuItem} from "primeng/api";
import { of, Subject, Observable, take, delay, takeUntil } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { signal } from "@angular/core";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ComuneDTO } from "src/app/models/comune.model";
import { SegnalazioniService } from "src/app/services/segnalazioni.service";
import { UtentiService } from "src/app/services/utenti.service";
import { ComuniService } from "src/app/services/comuni.service";
import { AutoCompleteCompleteEvent } from "primeng/autocomplete";
import { Segnalazione } from "src/app/models/segnalazione.model";
import { UserService } from "src/app/services/user.service";
import { AreaCompetenza } from "src/app/models/areaCompetenza.model";
import { TipoSegnalazione } from "src/app/models/tipoSegnalazione.model";
import { AreeCompetenzaService } from "src/app/services/areeCompetenza.service";
import { TipiSegnalazioneService } from "src/app/services/tipiSegnalazione.service";
import {getAverageLonLatSostegni, Sostegno} from "src/app/models/sostegno.models";
import { NominatimService } from "src/app/services/nominatim.service";
import { NominatimResponse } from "src/app/models/nominatim/response.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import {PosizioneSegnalazione} from "../../../models/posizione-segnalazione";
import {
  LocalizeIssueActivityWidgetComponent
} from "../../../components/localize-issue-activity-widget/localize-issue-activity-widget.component";
import { calculateCenterFromWktStrings } from "src/app/utils/map.util";

const INITIAL_POSITION_STATE: PosizioneSegnalazione = {
  sostegni: [],
  coordinates: null,
  indirizzo: null,
  edifici: []
};

@Component({
  selector: "crea-segnalazione",
  templateUrl: './crea-segnalazione.component.html',
  styleUrls: ['../segnalazioni.component.css']
})
export class CreaSegnalazioneComponent implements OnInit, OnDestroy {

  @ViewChild(LocalizeIssueActivityWidgetComponent) siglocmap: LocalizeIssueActivityWidgetComponent;

  protected _onDestroy = new Subject<void>();

  protected creaSegnalazioneForm: FormGroup;
  protected ref: DynamicDialogRef;

  protected comuni:ComuneDTO[]=[];
  protected filteredComuni: any[] =[];
  protected showComuni:Boolean = false;
  protected isSegnalatore:Boolean = false;
  protected sostegnoSelezionato:Sostegno;

  protected pagineCreaSegnalazione: MenuItem[];
  protected activeIndex: number = 0;

  protected areeCompetenza:AreaCompetenza[]=[];
  protected tipiSegnalazione:TipoSegnalazione[]=[];

  //protected indirizzi: Observable<any[]> = of([]);
  protected indirizzi:NominatimResponse[]=[];
  protected indirizziObs:Observable<NominatimResponse[]>=of([]);
  filteredIndirizzi: any[];
  protected selectedFiles: File[] = [];
  protected isFileUploaded: boolean = false;

  // aggiunto per evitare discrepanze tra autocomplete e input disattivato se l'utente è segnalatore
  protected selectedComune: ComuneDTO;

  protected mapPosition = signal<PosizioneSegnalazione>(INITIAL_POSITION_STATE);
  protected showSostegni: boolean;

  protected hasValidPosition = computed(() => {
    const pos = this.mapPosition();
    return !!pos.coordinates || pos.sostegni?.length > 0 || pos.edifici?.length > 0;
  });

  protected isSaving = signal(false);
  private destroy$ = new Subject<void>();

  @HostBinding("class.mobile") isMobile: boolean;
  constructor(
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private _formBuilder: FormBuilder,
      private segnalazioniService: SegnalazioniService,
      private utenteService:UtentiService,
      public dialogService: DialogService,
      private comuniService: ComuniService,
      protected userService:UserService,
      protected areeCompetenzaService:AreeCompetenzaService,
      protected tipiSegnalazioneService:TipiSegnalazioneService,
      private nominatimService: NominatimService,
      private googleStorageService: GoogleStorageService,
    ) {
      this.detectDevice();
      this.updatePosition(null);
  }

  detectDevice() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    this.isMobile = isMobile;
  }

  ngOnInit(): void {
    this.isSegnalatore = this.userService.isSegnalatore;
    // this.logger.info("1 ngOnInit "+  this.isSegnalatore );

    if (this.isSegnalatore) {
      this.selectedComune = this.userService.getUser().comune;
    }

    //this.loadUtente();
    this.loadComuni();
    this.loadAreeCompetenza();
    this.inizializzaSteps();
    this.creaSegnalazioneForm = this._formBuilder.group({
      autore:         new FormControl({value: this.userService.getUser(), disabled: false}, Validators.required),
      comune:         new FormControl({value: this.userService.getUser().comune ? this.userService.getUser().comune.denominazione : null, disabled: true}, Validators.required),
      areaCompetenza: new FormControl({value: null, disabled: false}, Validators.required),
      tipo:           new FormControl({value: null, disabled: true}, Validators.required),
      descrizione:    [null],
      segnalatore:    [null],
    });

    this.creaSegnalazioneForm.valueChanges.subscribe(() => {
      this.showSostegni = this.creaSegnalazioneForm.get("areaCompetenza")?.value?.label == "PUBBLICA";
    });

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  geocodificaIndirizzo(event: any){
    const query = event.query;

    this.nominatimService.searchAddress(query, this.creaSegnalazioneForm.get("comune").value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((results: NominatimResponse[]) => {
        this.filteredIndirizzi = results.map(result => ({
          indirizzo: result.display_name.split(',')[0].trim(),
          latitudine: result.lat,
          longitudine: result.lon
        }));
      });
  }

  loadAreeCompetenza(){
    if(this.userService.getUser().comune){
      this.areeCompetenza = this.userService.getUser().comune.areeCompetenza;
    }else{
      this.areeCompetenzaService.get()
      .pipe(takeUntil(this.destroy$))
      .subscribe(areeCompetenzaFromDB =>{
        this.areeCompetenza = areeCompetenzaFromDB;
      });
    }
  }
  
  //TODO: non utilizzata, da rimuovere?
  loadUtente(){
    this.utenteService.getByIdAuth0(localStorage.getItem("idUtente"))
    .pipe(takeUntil(this.destroy$))
    .subscribe(utente =>{

    });
  }

  onAreaCompetenzaSelect(event:any){
    this.tipiSegnalazioneService.getByAreaCompetenza(event.value.id)
    .pipe(take(1))
    .subscribe(tipiSegnalazioneFromDB=>{
      this.tipiSegnalazione = tipiSegnalazioneFromDB;
    });
    this.creaSegnalazioneForm.get('tipo')?.enable();
    this.creaSegnalazioneForm.get('tipo')?.setValue(null);
    this.mapPosition.set(INITIAL_POSITION_STATE);
  }


  changePage(shift: number) {
    this.activeIndex = this.activeIndex + shift;
    // console.log("comune dopo cambio pagina ", this.selectedComune);
    // console.log("posizione dopo cambio pagina: ", {...this.mapPosition})
  }

  checkNextStep(): boolean {
    let disableNextStepButton = false;
    if (this.activeIndex === this.pagineCreaSegnalazione.length - 1) {
      disableNextStepButton = true;
    } else if (this.activeIndex === 1) {
      // disableNextStepButton = !(this.posizioneForm.get("coordinate")?.value);
      disableNextStepButton = !this.hasValidPosition();
    } else if (this.activeIndex === 0 && !this.creaSegnalazioneForm.valid) {
      disableNextStepButton = true;
    }
    return disableNextStepButton;
  }

  inizializzaSteps() {
    this.pagineCreaSegnalazione = [
      {
        label: "Dettagli",
      },
      {
        label: "Localizzazione",
      },
      {
        label: "Allegati",
      }
    ];
    this.activeIndex = 0;
  }

 onComuneSelect(comune: ComuneDTO){
    // console.log("selecting comune ", comune, "against", this.selectedComune);
    // console.log("changed comune? ", comune != this.selectedComune);
    this.creaSegnalazioneForm.get("comune").setValue(comune);
    this.updatePosition(null);
    this.selectedComune = comune;

  }

  loadComuni() {
    this.comuniService.get()
    .pipe(take(1))
    .subscribe((res) => {
      this.comuni = res;
      if(!this.isSegnalatore){
        this.creaSegnalazioneForm.get("comune").enable();
      }

    });
  }

  filterComune(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.comuni.length; i++) {
        let comune = this.comuni[i];
        if (comune.denominazione.toLowerCase().indexOf(query.toLowerCase()) == 0) {
          filtered.push(comune);
        }
    }
    this.filteredComuni = filtered;
  }

  onFileUpload($event) {
    // this.logger.info($event);
    this.selectedFiles = $event.files;
    if(this.selectedFiles.length > 0){
      this.isFileUploaded = true;
    }
   /*
    this.selectedFile = $event.files[0]; */
  }
  onFileRemove() {
    if(this.selectedFiles.length == 0){
      this.isFileUploaded = false;
    }

  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
      return;
    }
    this.isSaving.set(true);
    let segnalazione:Segnalazione = new Segnalazione();
    segnalazione.autore           = this.userService.getUser();
    // segnalazione.comune           = this.creaSegnalazioneForm.get("comune").value;
    segnalazione.comune           = this.selectedComune;
    segnalazione.descrizione      = this.creaSegnalazioneForm.get("descrizione").value;
    segnalazione.segnalatore      = this.creaSegnalazioneForm.get("segnalatore").value?this.creaSegnalazioneForm.get("segnalatore").value:null;
    segnalazione.tipoSegnalazione = this.creaSegnalazioneForm.get("tipo").value;
    if (this.mapPosition().sostegni?.length > 0) {
      segnalazione.sostegni = [...this.mapPosition().sostegni];
    } else if (this.mapPosition().edifici?.length > 0) {
      segnalazione.edifici = [...this.mapPosition().edifici];
    }

    if (this.mapPosition().coordinates) {
      segnalazione.coordinate = {...this.mapPosition().coordinates};
    } else if (this.mapPosition().sostegni?.length > 0) {
      segnalazione.coordinate = getAverageLonLatSostegni(this.mapPosition().sostegni);
    } else if (this.mapPosition().edifici?.length > 0) {
      const wktStrings = this.mapPosition().edifici.map(edificio => edificio.geom);
      segnalazione.coordinate = calculateCenterFromWktStrings(wktStrings);
      segnalazione.isCoordinateCalculated = true;
    }

    segnalazione.indirizzo = this.mapPosition().indirizzo;
    if(this.isFileUploaded){
      segnalazione.allegato = true;

    }
    
    this.segnalazioniService.crea(segnalazione)
    .subscribe({
    next: (segnalazioneCreata) => {
      if(this.isFileUploaded){
        // this.logger.info(segnalazioneCreata);

        //TODO: CARICA FILE SU STORAGE
          this.selectedFiles.forEach(allegato => {
            //TODO: carica più file con più chiamate, perché non con una sola? Essendo una promise perdiamo traccia se c'è un errore, diamo per assodato che l'upload funzioni.
            this.googleStorageService.uploadAllegatoSegnalazioneToGoogleStorage(allegato,segnalazioneCreata.codice);
          });
          this.dialogRef.close({ success: true});
      }else{
        this.dialogRef.close({ success: true});
      }
      this.isSaving.set(false);
    },
    error: (error) => {
      //TODO: come mai non si mappa l'errore o lo si logga da qualche parte?
      // console.error('ERRORE CREAZIONE SEGNALAZIONE' + error);
      this.dialogRef.close({
        success: false
      });
      this.isSaving.set(false);
    }});

  }

  updatePosition(position: PosizioneSegnalazione | null) {
    if (!position) {
      this.mapPosition.set(INITIAL_POSITION_STATE);
      return;
    }
    this.mapPosition.set({
      sostegni: [...position.sostegni],
      coordinates: position.coordinates ? { ...position.coordinates } : null,
      indirizzo: position.indirizzo,
      edifici: [...position.edifici]
    });
  }

}
